import { useEffect, useState, type ReactElement } from 'react';
import { ArrowUpRight, Flame, TrendingUp } from 'lucide-react';
import type { ArticleSummary, TrendingTopic } from '@ai-radar/shared';
import { api } from '../api';
import { formatRelativeTime } from '../lib/format';
import { Link } from 'react-router-dom';

export function RightRail(): ReactElement {
  const [stories, setStories] = useState<ArticleSummary[]>([]);
  const [topics, setTopics] = useState<TrendingTopic[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    void Promise.all([api.topStories(controller.signal), api.trending(controller.signal)])
      .then(([nextStories, nextTopics]) => { setStories(nextStories); setTopics(nextTopics); })
      .catch(() => undefined);
    return () => controller.abort();
  }, []);

  return (
    <aside className="hidden space-y-5 xl:block">
      <section className="surface overflow-hidden">
        <div className="flex items-center justify-between border-b border-line px-4 py-3"><h2 className="flex items-center gap-2 text-sm font-semibold text-ink"><Flame size={15} className="text-accent" /> Top stories</h2><span className="text-[10px] font-medium uppercase tracking-[0.12em] text-subtle">24h</span></div>
        <div className="divide-y divide-line">
          {stories.slice(0, 5).map((article, index) => <Link key={article.id} to={`/article/${article.id}`} className="group block px-4 py-3 transition hover:bg-panel-muted"><div className="flex gap-3"><span className="font-display text-lg font-semibold text-subtle/70">0{index + 1}</span><div className="min-w-0"><h3 className="line-clamp-3 text-[12px] font-semibold leading-5 text-ink group-hover:text-accent">{article.title}</h3><div className="mt-1 flex items-center gap-1.5 text-[10px] text-muted"><span>{article.source.name}</span><span>·</span><span>{formatRelativeTime(article.publishedAt)}</span></div></div></div></Link>)}
          {stories.length === 0 && <p className="px-4 py-5 text-xs leading-5 text-subtle">Le storie più importanti compariranno qui dopo la prima raccolta.</p>}
        </div>
      </section>

      <section className="surface overflow-hidden">
        <div className="flex items-center gap-2 border-b border-line px-4 py-3"><TrendingUp size={15} className="text-accent" /><h2 className="text-sm font-semibold text-ink">Trending topics</h2></div>
        <div className="space-y-2 p-4">
          {topics.slice(0, 10).map((topic, index) => <Link key={topic.id} to={`/search?topic=${encodeURIComponent(topic.slug)}`} className="flex items-center justify-between rounded-lg px-2 py-1.5 text-xs transition hover:bg-panel-muted"><span className="flex items-center gap-2 text-muted"><span className="w-4 font-mono text-[10px] text-subtle">{index + 1}</span><span className="font-medium text-ink">{topic.name}</span></span><span className="flex items-center gap-1 text-[10px] text-subtle">{topic.articleCount}<ArrowUpRight size={11} /></span></Link>)}
          {topics.length === 0 && <p className="text-xs leading-5 text-subtle">I topic ricorrenti appariranno qui automaticamente.</p>}
        </div>
      </section>
    </aside>
  );
}
